export const getSentimentColor = (sentiment: string | undefined) => {
  if (!sentiment) {
    return "#000000"; // Default color for unknown sentiment
  }

  switch (sentiment) {
    case "excited":
      return "#32CD32";
    case "frustrated":
      return "#E53935";
    case "angry":
      return "#B71C1C";
    case "happy":
      return "#00B894";
    case "dodgy":
      return "#FF8800";
    case "neutral":
      return "#B0B0B0";
    case "mixed":
      return "#FFD93D";
    default:
      return "#000000"; // Default color for unknown sentiment
  }
};

export const getSentimentChurnSeverityColor = (severity: string | undefined) => {
  if (!severity) {
    return "#000000"; // Default color for unknown severity
  }

  switch (severity) {
    case "high":
      return "#D32F2F"; // Red for high severity
    case "medium":
      return "#F57C00"; // Orange for medium severity
    case "low":
      return "#FBC02D"; // Green for low severity
    default:
      return "#000000"; // Default color for unknown severity
  }
};

export const getSentimentPositiveSeverityColor = (severity: string | undefined) => {
  if (!severity) {
    return "#000000"; // Default color for unknown severity
  }

  switch (severity) {
    case "high":
      return "#2E7D32"; // Red for high severity
    case "medium":
      return "#66BB6A"; // Orange for medium severity
    case "low":
      return "#A5D6A7"; // Green for low severity
    default:
      return "#000000"; // Default color for unknown severity
  }
};
